import React, {Component} from 'react';
import './Talks.css';

class Talks extends Component {


render() {
    return (
        <div id="talks" className="row home-block">
            <div>
                <h2 className="title">Talks & Tutorials</h2>

                <div className="type-publication">Talks</div>
                <ul className="talks-list">


                    <li><a href="https://drive.google.com/file/d/1rQ610NKF0XDJaRmHxJRVuSzLNULp57IH/view?usp=sharing">2025 — Tutorial: Diffusion Models</a> in Practice, University of Marseille</li>

                    <li><a href="https://drive.google.com/file/d/1267gnRgrlXxmuSG1snwpohy0-dnZVy_L/view?usp=sharing">2025 — Tutorial: Reinforcement Learning in Practice, LAAS (CNRS)</a></li>

                    <li> 2025 — Tutorial: VAE and Diffusion Models, University of Strasbourg</li>
                    <li> 2025 — Study of Diffusion Models for Editing Sports Dance Images, University of Strasbourg</li>
                    <li> 2024 — Introduction to RL and Multi-Armed Bandits, INRAE MIAT</li>
                    <li> 2024 — Why RL? SPOT Toulouse</li>
                    <li> 2023 — Dynamic Allocation Optimization in A/B Tests Using Classification-Based Preprocessing, Institut de Mathématiques de Toulouse</li>
                    <li> 2023 — Dynamic Allocation Optimization in A/B Tests Using Classification-Based Preprocessing, University of Avignon</li>
                    <li> 2021 — From Process Mining to Pathway Prediction, LACL</li>
                    <li> 2020 — Dynamic Allocation Optimization in A/B Tests Using Classification-Based Preprocessing, AOC Toulouse</li>

                </ul>
            </div>
        </div>
    );
}


}

export default Talks;



// WEBPACK FOOTER //
// ./src/Components/Talks/Talks.js